import { TranslateService } from '@ngx-translate/core';
import { PageResponse } from '@models/page-response';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { CommonService } from '@services/common.service';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Deployment, PublishSearchingCriteria } from '@app/models/deployment';
import { CommonResponse } from '@app/models/common-model';


@Injectable()
export class DeploymentService {

    constructor(
        private httpClient: HttpClient,
        private commonService: CommonService,
        private translate: TranslateService
    ) { }

    globalSearch(globalCriteria: string = '', criteria: PublishSearchingCriteria, page: number = 0, size: number = 10, sortField: string, sortDirection: string = 'asc'): Observable<PageResponse<Deployment>> {

        let params: HttpParams = new HttpParams();
        params = params.set('global', globalCriteria);
        params = params.set('criteria', JSON.stringify(criteria == null ? new PublishSearchingCriteria() : criteria));
        params = params.set('page', page.toString());
        params = params.set('size', size.toString());
        if (sortField != null) {
            params = params.set('sort', sortField + ',' + sortDirection);
        }

        return this.httpClient.get(`${environment.API_END_POINT}/deployment`, { headers: this.commonService.getHeaders(), params: params })
            .pipe(
                map(response => {
                    let tempObj = <Deployment[]>(<any>response);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    insert(emailTemplate: Deployment): Observable<Deployment> {

        let body = JSON.stringify(emailTemplate);

        return this.httpClient.post(`${environment.API_END_POINT}/deployment`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <Deployment[]>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    get(id: string): Observable<Deployment> {
        return this.httpClient.get(`${environment.API_END_POINT}/deployment/${id}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <Deployment>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    update(emailTemplate: Deployment): Observable<Deployment> {
      
        let body = JSON.stringify(emailTemplate);

        return this.httpClient.put(`${environment.API_END_POINT}/deployment/${emailTemplate.id}`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <Deployment[]>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    deploy(templateId: string): Observable<string> {

        return this.httpClient.get(`${environment.API_END_POINT}/deployment/deploy/${templateId}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    // let tempObj = <OnepageTemplate[]>((<any>response).content);
                    return response;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    
    disable(templateId: string, isDisable:boolean=false): Observable<CommonResponse> {

        return this.httpClient.get(`${environment.API_END_POINT}/deployment/disable/${templateId}/${isDisable}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    return response;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    findAll(): Observable<Deployment[]> {


        return this.httpClient.get(`${environment.API_END_POINT}/deployment/all`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => {
                    let tempObj = <Deployment[]>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }


}